/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class PostContentLink extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            postContentLink: null
        };

    }

    static getDerivedStateFromProps(props, state) {

        if (props.item && props.item.hasOwnProperty('tweet_id')) {
            return {
                postContentLink: props.item.source
            };
        } else if (props.item && props.item.longUrl) {
            return {
                postContentLink: props.item.longUrl
            };
        }

        return null;

    }

    render() {

        let postContentLink = null,
            linkContent = (this.props.content !== null) ? this.props.content : 'view';

        if (this.state.postContentLink) {
            postContentLink = (
                <a href={this.state.postContentLink} target="_blank">
                    {linkContent}
                </a>
            );
        }

        return postContentLink;
    }

};

PostContentLink.propTypes = {
    item: PropTypes.object,
    content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
};

PostContentLink.defaultProps = {
    item: {},
    content: null
};

export default PostContentLink;
